/**
 * Google Calendar event `colorId` palette (API ids "1"–"11").
 * Hex values match Google's published event colors for preview swatches in admin.
 * These are external platform colors (not tenant theme tokens).
 */

export type GoogleCalendarColorChoice = {
  id: string;
  label: string;
  /** Approximate Google Calendar swatch for admin preview */
  hex: string;
};

export const GOOGLE_CALENDAR_COLOR_CHOICES: GoogleCalendarColorChoice[] = [
  { id: "1", label: "Lavender", hex: "#7986CB" },
  { id: "2", label: "Sage", hex: "#33B679" },
  { id: "3", label: "Grape", hex: "#8E24AA" },
  { id: "4", label: "Flamingo", hex: "#E67C73" },
  { id: "5", label: "Banana", hex: "#F6BF26" },
  { id: "6", label: "Tangerine", hex: "#F4511E" },
  { id: "7", label: "Peacock", hex: "#039BE5" },
  { id: "8", label: "Graphite", hex: "#616161" },
  { id: "9", label: "Blueberry", hex: "#3F51B5" },
  { id: "10", label: "Basil", hex: "#0B8043" },
  { id: "11", label: "Tomato", hex: "#D50000" },
];

const COLOR_BY_ID = new Map(GOOGLE_CALENDAR_COLOR_CHOICES.map((c) => [c.id, c]));

export function googleCalendarColorHex(colorId: string | null | undefined): string | null {
  const id = (colorId ?? "").trim();
  return COLOR_BY_ID.get(id)?.hex ?? null;
}

export function googleCalendarColorLabel(colorId: string | null | undefined): string | null {
  const id = (colorId ?? "").trim();
  return COLOR_BY_ID.get(id)?.label ?? null;
}
